import { render, staticRenderFns } from "./StartseiteLeadManagement.vue?vue&type=template&id=c63e3310"
import script from "./StartseiteLeadManagement.vue?vue&type=script&lang=js"
export * from "./StartseiteLeadManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports